(function () {
  function bindExclusive(root) {
    if (root.getAttribute('data-exclusive') !== 'true') return;
    if (root.dataset.termsBound === '1') return;
    root.dataset.termsBound = '1';

    root.querySelectorAll('details.wholesale-terms-acc__item').forEach(function (det) {
      det.addEventListener('toggle', function () {
        if (!det.open) return;
        root.querySelectorAll('details.wholesale-terms-acc__item').forEach(function (other) {
          if (other !== det) other.open = false;
        });
      });
    });
  }

  function init() {
    document.querySelectorAll('.wholesale-terms-acc').forEach(bindExclusive);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector && event.target.querySelector('.wholesale-terms-acc');
    if (root) bindExclusive(root);
  });
})();
